export class ProductImageApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly reason?: string,
  ) {
    super(
      reason ||
        (status === 403 ? 'Access denied' : 'Unable to load vehicle imagery'),
    );
  }
}
